import { useEffect, useState } from 'react'
import { Icon, Avatar } from '../ui'
import { useAppStore } from '../../store/appStore'
import type { Profile } from '../../lib/types'

interface AvatarMenuProps {
  profile: Profile | null
  onSignOut: () => void
}

export function AvatarMenu({ profile, onSignOut }: AvatarMenuProps) {
  const { openSettings } = useAppStore()
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (!open) return
    const h = () => setOpen(false)
    window.addEventListener('click', h)
    return () => window.removeEventListener('click', h)
  }, [open])

  return (
    <div className="av-wrap" onClick={(e) => e.stopPropagation()}>
      <button className="av-btn" onClick={() => setOpen((o) => !o)} aria-label="Account menu">
        <Avatar name={profile?.name ?? 'User'} size={34} id={profile?.avatar_seed ?? 0} />
      </button>

      {open && (
        <div className="av-menu" role="menu">
          <div className="am-head">
            <Avatar name={profile?.name ?? 'User'} size={32} id={profile?.avatar_seed ?? 0} />
            <div>
              <div className="nm">{profile?.name ?? 'User'}</div>
              <div className="rl">{profile?.role ?? ''}</div>
            </div>
          </div>
          <button
            className="am-item"
            role="menuitem"
            onClick={() => {
              setOpen(false)
              openSettings('profile')
            }}
          >
            <Icon name="settings" size={15} />
            Settings
          </button>
          <button className="am-item" role="menuitem" onClick={() => setOpen(false)}>
            <Icon name="book" size={15} />
            Help
          </button>
          <button
            className="am-item danger"
            role="menuitem"
            onClick={() => {
              setOpen(false)
              onSignOut()
            }}
          >
            <Icon name="lock" size={15} />
            Sign out
          </button>
        </div>
      )}
    </div>
  )
}
